import React, {Component} from "react"
import {connect} from 'react-redux';

import moment from 'moment';

import Layout from "../../../components/Layout"
import FilterReports from "../../../components/FilterReports"
import leng from "../../../data"

import {
    DataTable,
    TableContainer,
    TableToolbar,
    TableToolbarContent,
    TableHead,
    TableRow,
    TableHeader,
    TableBody,
    Table,
    TableCell,
    DataTableSkeleton,
    Button, Pagination,
} from "carbon-components-react"

import "./index.scss"

import {
    reports_action_count, reports_action_fetch,
    reports_action_download
} from '../../../store/actions/reports';
import {Download20, Launch20} from "@carbon/icons-react";


const headers = [
    {key: "name", header: "Name"},
    {key: "origin", header: "Origin"},
    {key: "dateRefC", header: "Competency Period"},
    {key: "createdDateC", header: "Execution date"},
    {key: "user", header: "User"},
    {key: "download", header: ""},

];

const rowsTable = [];

class Report extends Component {

    state = {
        form: {}
    };

    componentDidMount() {
        this.props.countFiles();
        this.props.fetchData({error: false, skip: 0});
    }

    async onSubmitForm(data) {
        console.log(data);
        this.setState({form: data});
        this.props.fetchData({form: data, error: false, skip: 0});
    }

    async onChangePagination(arg1, arg2, arg3) {
        await this.props.fetchData({error: false, skip: arg1.page});
    }

    handleDownload = (originalFile, originalName, bucket) => e => {
        e.preventDefault();
        var name = originalName.split('/');
        var nameOriginal = name[name.length - 1];
        this.props.downloadFiles(originalFile, nameOriginal, bucket);
    };

    render() {
        let {data, isLoading} = this.props;

        let rows = data;
        //let rows = rowsTable;
        //console.log(rows);
        rows =
            data?.length > 0
                ? data.map(execution => {
                    return {
                        ...execution,
                        id: execution._id,
                        dateRefC: moment(execution.dateRef).format('MMM YYYY'),
                        createdDateC: moment(execution.createdDate).format('D MMM YYYY H:mm'),
                        download: (typeof execution.url !== "undefined" ? (
                                <div className="text-center">
                                    <a title="Fazer Download" href="#download"
                                       onClick={this.handleDownload(execution.originalFile, execution.originalName, execution.bucket)}>
                                        <Download20 size="small"/>
                                    </a>
                                    <a style={{marginLeft: "15px"}} title="Abrir"
                                       href={"https://view.officeapps.live.com/op/view.aspx?src=" + execution.url}
                                       target="_blank">
                                        <Launch20 size="small"/>
                                    </a>
                                </div>) : (<div className="text-center">
                                <a title="Fazer Download" href="#download"
                                   onClick={this.handleDownload(execution.originalFile, execution.originalName, execution.bucket)}>
                                    <Download20 size="small"/>
                                </a>
                                <a style={{marginLeft: "15px", pointerEvents: "none", opacity: "50%"}} title="Abrir"
                                   href={"https://view.officeapps.live.com/op/view.aspx?src=" + execution.url}
                                   target="_blank">
                                    <Launch20 size="small"/>
                                </a>
                            </div>)
                        )
                    };
                })
                : [];
        // if (rows?.length > 0) rows.sort((a, b) => b.sortDate - a.sortDate);
        //console.log(rows);
        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>{leng.sideBar.intelligentJourney.title}</p>
                        <h1>{leng.sideBar.intelligentJourney.links[2]}</h1>
                        <br/>
                    </div>
                </div>
                <div className="section-light">
                    <div className="section-light-heading">
                        <div className="file-upload-container">
                            <div>
                                <FilterReports
                                    form={this.state.form}
                                    onSubmitForm={(data) => this.onSubmitForm(data)}
                                />
                            </div>

                            <div>
                                {isLoading ? (
                                    <DataTableSkeleton/>
                                ) : (
                                    <DataTable rows={rows} headers={headers}>
                                        {({
                                              rows,
                                              headers,
                                              getHeaderProps,
                                              getRowProps,
                                              getTableProps,
                                              getSelectionProps,
                                              onInputChange,
                                          }) => (
                                            <TableContainer title={leng.repositorio.formato.table_title}
                                                            description={rows.length + " arquivos"}
                                                            className="upload-table">
                                                <TableToolbar>
                                                    <TableToolbarContent>
                                                    </TableToolbarContent>
                                                </TableToolbar>
                                                <Table {...getTableProps()}>
                                                    <TableHead>
                                                        <TableRow>
                                                            {headers.map((header) => (
                                                                <TableHeader
                                                                    key={header.key}
                                                                    {...getHeaderProps({header})}
                                                                >
                                                                    {header.header == leng.repositorio.formato_table_header.table[3] ?
                                                                        <div>{header.header}</div> :
                                                                        header.header
                                                                    }

                                                                </TableHeader>
                                                            ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {rows.map((row) => (
                                                            <TableRow
                                                                className="upload-row"
                                                                key={row.id}
                                                                {...getRowProps({row})}
                                                            >
                                                                {row.cells.map((cell) => (
                                                                    <TableCell key={cell.id}>
                                                                        {cell.value}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                                <Pagination
                                                    className="paginator"
                                                    totalItems={rows.length}
                                                    pageSizes={[20]}
                                                    backwardText="Previous"
                                                    forwardText="Next"
                                                    PageSize={20}
                                                    itemsPerPageText={"Items per page"}
                                                    onChange={(arg1, arg2, arg3) => {
                                                        this.onChangePagination(arg1, arg2, arg3);
                                                    }}
                                                ></Pagination>
                                            </TableContainer>
                                        )}
                                    </DataTable>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

const mapStateToProps = ({reports}) => reports;

const mapDispatchToProps = dispatch => ({
    countFiles: () => dispatch(reports_action_count()),
    fetchData: params => dispatch(reports_action_fetch(params)),
    downloadFiles: (originalName, originalFile, bucket) => dispatch(reports_action_download(originalName, originalFile, bucket))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Report);
